<template>
  <div class="pageDiv">
    <v-card class="main-card" v-if="!$AuthSvc.isLogin()">
      <v-card-text>
        <span class="label14 darkred">Login is required to view data</span>
      </v-card-text>
    </v-card>

    <v-card class="main-card" v-if="$AuthSvc.isLogin() ">
      <v-card-title style="padding-bottom:0">
        <span class="page-title">Players ({{displayPlayers.length}} found)</span>
      </v-card-title>
      <v-card class="letter-div">
        Select first letter of first name:
        <div class="letterContainer">
          <a class="letter-btn"
             v-for="letter in lettersMap" :key="letter"
             :class="{letterSelected: selectedLetter === letter.value}"
             @click="updateList(letter.value)">{{letter.key}}</a>
        </div>
      </v-card>

      <v-card class="player-card" v-if="displayPlayers.length === 0">
        No Players found {{displayPlayers.length}}
      </v-card>

      <v-card class="player-card"
              v-for="memberPlayer in displayPlayers" :key="memberPlayer.playerId">
        <div class="p-card">
          <div class="player-img-div">
            <v-img class="player-img" :src="'/images/players/' + memberPlayer.player.photoName">
            </v-img>
          </div>

          <v-card-text class="">
            <span class="label14">Name: </span>
            {{memberPlayer.player.firstName}} {{memberPlayer.player.middleName}} {{memberPlayer.player.lastName}}
            <v-img class="member-logo" v-if="memberPlayer.membership" src="../../assets/img/dfwvga-logo-mini.png">
            </v-img>
            <br>
            <span class="label14">Flight: </span> {{memberPlayer.player.defaultFlight}}<br>
            <span class="label14">Proximity: </span> {{memberPlayer.player.proximity}}<br>
            <span class="label14">HCP: </span> {{getScoreHcp(memberPlayer.player.dfwvgaHandicap, memberPlayer.player.handicap, 1)}}<br>
            <span class="label14">Shirt Size: </span> {{memberPlayer.player.shirtSize}}<br>

            <a class="label14 link" @click="getPlayerScore(memberPlayer)">See tournament scores & HCP</a>
          </v-card-text>
        </div>

        <v-card class="p-card" v-if="playerScores.length > 0 && selectedPlayer !== null && memberPlayer.seeScores">
          <v-card-text class="">
            <v-simple-table class="simple-table">
                <th width="10px">#</th>
                <th width="100px">Date</th>
                <th v-if="!$AuthSvc.isMobile()">Flight</th>
                <th v-if="!$AuthSvc.isMobile()">HCP</th>
                <th>Course</th>
                <th>Score</th>
                <th v-if="false && !$AuthSvc.isMobile()">C.R/Slope</th>
                <th>Adj</th>
                <th>Diff</th>
              </tr>
              <tr v-for="(player, index) in playerScores" :key="player.playerId">
                <td :class="{hcpChoice: player.selected}">{{index+1}}</td>
                <td>{{player.scoreDate}}</td>
                <td v-if="!$AuthSvc.isMobile()">{{player.flight}}</td>
                <td v-if="!$AuthSvc.isMobile()">{{$AuthSvc.getHcp(player.handicap)}}</td>
                <td>{{player.courseName}}</td>
                <td>{{player.thruHoles===18?player.score:"DNF"}}</td>
                <td v-if="false && !$AuthSvc.isMobile()">{{player.rating}} / {{player.slope}}</td>
                <td>{{player.thruHoles===18?player.adjScore:"DNF"}}</td>
                <td :class="{hcpSelected: player.hcpSelected==='Y'}">{{getScoreHcp(player.scoreHandicap, "", 1)}}</td>
              </tr>
              <tr>
                <td class="hcpLine"></td>
                <td class="hcpLine"></td>
                <td class="hcpLine" v-if="!$AuthSvc.isMobile()"></td>
                <td class="hcpLine" v-if="!$AuthSvc.isMobile()"></td>
                <td class="hcpLine"></td>
                <td class="hcpLine" v-if="false && !$AuthSvc.isMobile()"></td>
                <td class="hcpLine"></td>
                <td class="hcpLine label16">HCP</td>
                <td class="hcpLine label16">{{toScoreStr(memberPlayer.player.dfwvgaHandicap)}}</td>
              </tr>
            </v-simple-table>
          </v-card-text>
        </v-card>

        <v-card class="p-card"
                v-if="$AuthSvc.isMember() && playerScores.length === 0 && selectedPlayer !== null && selectedPlayer.playerId === memberPlayer.playerId">
          <v-card-text class="">
            <span class="label14" style="color: red !important">No scores recorded.</span>
          </v-card-text>
        </v-card>

        <v-card style="display:none" class="p-card"
                v-if="!$AuthSvc.isMember() && selectedPlayer !== null && selectedPlayer.playerId === memberPlayer.playerId">
          <v-card-text class="">
            <span class="label14" style="color: red !important">Must be a DFWVGA member to view scores.</span>
          </v-card-text>
        </v-card>
      </v-card>
    </v-card>
  </div>
</template>

<script>
  export default {
    name: "login",
    data: () => ({
      count: 0,
      selectedPlayer: null,
      playerScores: [],
      memberPlayers: [],
      displayPlayers: [],
      selectedLetter: '',
      lettersMap: [
        {"key":"A-C", "value":"ABC"},
        {"key":"D-F", "value":"DEF"},
        {"key":"G-I", "value":"GHI"},
        {"key":"J-L", "value":"JKL"},
        {"key":"M-O", "value":"MNO"},
        {"key":"P-S", "value":"PQRS"},
        {"key":"T", "value":"T"},
        {"key":"U-Z", "value":"UVWXYZ"}
      ],
      letters: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I','J','K','L','M','N','O','P','Q','R','S',
                'T','U','V','W','X','Y','Z']
    }),
    mounted: function() {
      if (this.$AuthSvc.isLogin()) {
        this.loadPlayers();
      }
    },
    methods: {
      loadPlayers() {
        var _this = this;
        this.selectedLetter = this.lettersMap[0].value;
        this.axios.get('/public/players/letter/' + this.lettersMap[0].value)
        .then(function (response) {
            _this.memberPlayers = response.data;
            for(var i=0; i < _this.memberPlayers.length; i++) {
              _this.memberPlayers[i].match = true;
              _this.memberPlayers[i].seeScores = false;
              _this.memberPlayers[i].noScores = false;
            }
            _this.displayPlayers = _this.memberPlayers;
        })
        .catch(function (error) {
            console.log('ERROR 1: ' + error);
        });
      },
      toScoreStr(handicap) {
        if (handicap > 50) {
          return "N/A"
        } else {
          return Number(handicap).toFixed(1);
        }
      },
      getScoreHcp(scoreHcp, overrideHcp, precision) {
        var hcp = scoreHcp;
        if (overrideHcp != null && overrideHcp !== '') {
          hcp = overrideHcp;
        }

        if (hcp === '') {
          return "N/A";
        }

        if (hcp > 60.00) {
          return "N/A";
        }
        else {
          return Number(hcp).toFixed(precision);
        }
      },
      processKey(event) {
        if (event.keyCode === 13) {
          this.updateList();
        }
      },
      updateList(letter) {
        var _this = this;

        _this.selectedLetter = letter;
        this.axios.get('/public/players/letter/' + letter)
        .then(function (response) {
            _this.memberPlayers = response.data;
            for(var i=0; i < _this.memberPlayers.length; i++) {
              _this.memberPlayers[i].match = true;
            }
            _this.displayPlayers = _this.memberPlayers;
        })
        .catch(function (error) {
            console.log('ERROR 2: ' + error);
        });
      },
      membershipChange(memberPlayer) {
        if (memberPlayer.membership) {
          this.axios.post('/admin/member/' + this.$AuthSvc.getYear() + '/'+memberPlayer.playerId)
          .then(function (response) {
            console.log("SUCCESS: " + response.data);
          })
          .catch(function (error) {
            console.log('ERROR 3: ' + error);
          });
        } else {
          this.axios.delete('/admin/member/' + this.$AuthSvc.getYear() + '/'+memberPlayer.playerId)
          .then(function (response) {
            console.log("SUCCESS: " + response.data);
          })
          .catch(function (error) {
            console.log('ERROR 4: ' + error);
          });
        }
      },
      excludeTcChange(memberPlayer) {
        if (memberPlayer.player.excludeTc==='Y') {
          this.axios.post('/admin/exclude-tc/'+memberPlayer.playerId)
          .then(function (response) {
            console.log("SUCCESS: " + response.data);
          })
          .catch(function (error) {
            console.log('ERROR 5: ' + error);
          });
        } else {
          this.axios.delete('/admin/exclude-tc/'+memberPlayer.playerId)
          .then(function (response) {
            console.log("SUCCESS: " + response.data);
          })
          .catch(function (error) {
            console.log('ERROR 6: ' + error);
          });
        }
      },
      getPlayerScore(memberPlayer) {
        var _this = this;
        if (_this.selectedPlayer != null) {
          _this.selectedPlayer.seeScores = false;
        }
        _this.selectedPlayer = memberPlayer;

        this.axios.get('/public/scores-history/players/'+memberPlayer.playerId)
        .then(function (response) {
          console.log("SUCCESS: " + response.data);
          _this.playerScores = response.data;
          _this.selectedPlayer.seeScores = true;

          if (_this.playerScores.length === 0 ) {
            _this.selectedPlayer.noScores = true;
          }

          var cnt = 0;
          for(var i=0; i < _this.playerScores.length; i++) {
            if (_this.playerScores[i].thruHoles === 18) {
              _this.playerScores[i].selected = true;
              cnt++
              if (cnt >= 10) {
                break;
              }
            }
          }
        })
        .catch(function (error) {
          console.log('ERROR 1: ' + error);
        });

      }
    }
  }

</script>

<style scoped>

    .p-card {
      width: 100%;
    }

    select {
      margin-right: 10px;
    }

    .checkbox {
      height: 20px;
      width: 20px;
    }

    .input-text {
      width: 60px;
      border: 1px solid black;
      border-radius: 5px;
      padding: 3px 7px !important;
    }

    .btn-action {
      display: inline-block;
    }

    .label {
      font-size: 14px;
      font-weight: bold;
      display: inline-block;
      width: 100px;
    }

    .player-card {
      margin: 10px 0;
      padding: 10px;
      min-height: 200px !important;
    }

    .player-subcard span {
      display: inline-block;
      margin-right: 12px;
    }

    .player-content {
      margin: 7px 10px !important;
      height: 28px;
    }

    .actions-card {
      display: inline-block;
      float: right;
      width: 80px !important;
    }

    .noShow {
      display: none;
    }

    .hcpLine {
      border: 0px;
      background-color: lightgreen;
    }

    .letterContainer {
      display: inline-block;
      width: 100%;
      padding: 7px;
    }

    @media (min-width: 768px) {
      .player-subcard {
        display: flex;
        padding: 5px;
        width: 300px !important;
      }

      .player-score-subcard {
        display: flex;
        padding: 5px;
        width: 100% !important;
      }

      .player-content {
        width: 240px;
        height: 28px;
      }

      .letter-div {
        display: inline-block;
        width: 100%;
      }

      td, th {
        font-size: 14px;
      }
    }

    .letter-btn {
      display: inline-block;
      font-size: 20px;
      font-weight: 900;
      margin: 5px;
      padding: 5px !important;
      background-color: #163b7a !important;
      color: white;
      border-radius: 5px;
    }

    .p-card {
      display: flex;
    }

    .player-img-div {
      position: relative;

      width: 140px;
      margin-right: 20px;
    }

    .player-img {
      border-radius: 7px;
      margin-bottom: 10px;
      max-height: 175px;
    }

    .letterSelected {
      color: #163b7a;
      background-color: #c3dbfa !important;
    }

    .membership {
      font-size: 14px;
      font-weight: bold;
      color: darkgreen;
    }

    .memberColor {
      background-color: antiquewhite;
    }

    .hcpSelected {
      background-color: lightgreen;
    }

    .hcpChoice {
      background-color: lightgrey;
    }

    .member-logo {
      display: inline-block;
      height: 40px;
      width: 40px;
      border-radius: 45px;
      margin-left: 10px;
    }

</style>